export default "__VITE_ASSET__CgD48wXj__"